"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemRowDescription = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _culture = require("@ori/culture");
var _constants = require("../../../constants");
var _FormattedMessage = require("../../FormattedMessage");
var _shared = require("../../shared");
var _jsxRuntime = require("react/jsx-runtime");
const sharedBottomAlignment = theme => ({
  bottom: theme.spacing(2),
  [theme.breakpoints.only('xs')]: {
    bottom: theme.spacing(1)
  },
  [theme.breakpoints.down(_constants.XXS)]: {
    bottom: theme.spacing(0)
  }
});
const Root = (0, _mui.styled)('div')(() => ({
  flexGrow: 1,
  position: 'relative'
}));
const Description = (0, _mui.styled)(_mui.Typography)(({
  ownerState: {
    isReplacement
  },
  theme
}) => ({
  ...(0, _shared.lineClampStyles)(2),
  ...(0, _shared.textStyles)(theme),
  lineHeight: 1.25,
  paddingRight: isReplacement ? theme.spacing(6) : 0
}));
const ReplacementIcon = (0, _mui.styled)('span')(({
  theme
}) => ({
  alignItems: 'center',
  color: theme.palette.grey[300],
  display: 'flex',
  fontSize: '2.4rem',
  height: 30,
  justifyContent: 'center',
  position: 'absolute',
  right: theme.spacing(-1),
  top: theme.spacing(-1),
  width: 30
}));
const ItemCode = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: 'block',
  ...(0, _shared.textStyles)(theme)
}));
const Quantity = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  left: 0,
  position: 'absolute',
  ...sharedBottomAlignment(theme)
}));
const Prices = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'block',
  position: 'absolute',
  right: 0,
  textAlign: 'right',
  ...sharedBottomAlignment(theme)
}));
const OriginalPrice = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => (0, _shared.originalPriceStyles)(theme));
const ItemRowDescription = ({
  isPurchased,
  itemCode,
  name,
  price,
  purchasePrice,
  replacement,
  selectedQuantity
}) => {
  const isReplacement = Boolean(replacement);
  const ownerState = {
    isReplacement
  };
  const isPurchasePriceDefined = typeof purchasePrice !== 'undefined';
  const isPriceDefined = typeof price !== 'undefined';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Description, {
      variant: "body1",
      ownerState: ownerState,
      children: name
    }), replacement ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
      placement: "bottom-end",
      title: replacement,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ReplacementIcon, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Replace, {
          fontSize: "inherit"
        })
      })
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(ItemCode, {
      variant: "caption",
      color: "grey.A700",
      children: itemCode
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Quantity, {
      variant: "body1",
      color: isPurchased ? 'text.primary' : 'text.secondary',
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "qty"
      }), " ", selectedQuantity]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Prices, {
      children: [isPurchasePriceDefined && purchasePrice !== price ? /*#__PURE__*/(0, _jsxRuntime.jsx)(OriginalPrice, {
        variant: "caption",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_culture.FormatCurrency, {
          children: Number(purchasePrice)
        })
      }) : null, isPriceDefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "body1",
        color: "text.secondary",
        fontWeight: "bold",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_culture.FormatCurrency, {
          children: price
        })
      }) : null]
    })]
  });
};
exports.ItemRowDescription = ItemRowDescription;